module.exports = __webpack_public_path__ + "static/media/logo-kanjiko.17da1e41.svg";